

export enum EquipmentTypeEnum {
    LTL = 'ltl',

    FTL = 'ftl'
}